<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 text-xs-center m0a>
        <label><h2>Date Range</h2></label>
        <v-flex xs6 m0a>
          <v-select v-model="enableProductTypes" :items="availableProductTypes" chips clearable label="Filter Types" multiple ></v-select>
        </v-flex>
        <v-flex xs6 m0a>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="320px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFrom"
                label="Date from"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateFrom"
              @input="menu1 = false"
              :max="new Date().toISOString().substr(0, 10)"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 m0a>
          <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="320px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateTo"
                label="Date to"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateTo"
              @input="menu1 = false"
              :min="dateFrom"
              :max="new Date().toISOString().substr(0, 10)"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 m0a>
          <v-btn color="primary" text @click="getRecords()" > Get Records </v-btn>
        </v-flex>
      </v-flex>
      <v-flex xs8 text-xs-center m0a v-if='items.length > 0 && showData === true'>
        <table class="itemRecords" width='100%'>
          <tr>
            <th>Item Type</th>
            <th>Total Items</th>
            <th>Total Amount</th>
          </tr>
          <tr class="text-xs-center" v-for="(item, index) in items" :key="index">
            <td>{{item[0]}}</td>
            <td>{{item[1]}}</td>
            <td>${{item[2]}}</td>
          </tr>
        </table>
      </v-flex>
      <v-flex xs8 text-xs-center m0a v-if='items.length === 0 && showData === true'>
        No Record found.
      </v-flex>
      <v-flex xs8 text-xs-center m0a v-if="showData === false">
        <v-progress-circular
        indeterminate
        color="primary">
        </v-progress-circular>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import OrderService from '@/services/OrderService'
import moment from 'moment'
export default {
  data () {
    return {
      showData: true,
      snackbar: false,
      popupText: null,
      dateFrom: moment().format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      items: [],
      menu1: false,
      enableProductTypes: [],
      availableProductTypes: ['Roller Blind',
        'Linked Roller Blind',
        'Double Roller Blind',
        'Linked Double Roller Blind',
        'Roman Blind',
        'Soft Roman Blind',
        'Venetian Blind',
        'Honeycomb Blind',
        'Shutter',
        '3D Shutters',
        'Panel Glide Blind',
        'Vertical Blind',
        'Curtain',
        'Double Curtain',
        'Lined Curtain',
        'Curved Curtain',
        // 'Corner Curtain',
        'Motor Accessories',
        'Pelmets',
        'Misc'],
      loggedInUser: JSON.parse(atob(localStorage.getItem('user')))
    }
  },
  mounted () {
  },
  methods: {
    async getRecords () {
      this.showData = false
      let enableProductTypes = this.enableProductTypes
      console.log(enableProductTypes.length)
      if (enableProductTypes.length === 0) {
        enableProductTypes = this.availableProductTypes
      }
      let params = {dateFrom: this.dateFrom, dateTo: this.dateTo, enableProductTypes: enableProductTypes}
      let response = await OrderService.getOrderDetails(params)
      console.log(response)
      var items = []
      var orderItems = response.data.items
      // for (let index = 0; index < orders.length; index++) {
      //   const order = orders[index]
      for (let index2 = 0; index2 < orderItems.length; index2++) {
        const item = orderItems[index2]
        if (!Array.isArray(items[item.type])) {
          items[item.type] = []
          items[item.type]['total'] = 0
          items[item.type]['totalAmount'] = 0
        }
        items[item.type]['total'] += 1
        items[item.type]['totalAmount'] += item.total
      }
      // }
      this.items = []
      items = Object.assign({}, items)
      for (var prop in items) {
        var itemType = prop
        var itemProps = Object.assign({}, items[prop])
        var itemTotal = itemProps.total
        var itemTotalAmount = itemProps.totalAmount
        this.items.push([itemType, itemTotal, this.numberWithCommas(itemTotalAmount)])
      }
      this.showData = true
    },
    numberWithCommas (x) {
      if (x) {
        var parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      } else {
        return 0
      }
    }
  }
}
</script>
<style scoped>
  .m0a { margin: 0 auto; }
  .itemRecords { font-size: 20px; }
</style>



// WEBPACK FOOTER //
// src/components/admin/OrderDetails.vue